"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _nano = require("./nano");
var _default = exports["default"] = (0, _nano.sheet)({
  tabTrap: {
    position: 'absolute',
    height: 0,
    width: 0,
    padding: 0,
    border: 'none',
    margin: 0,
    opacity: 0
  }
});